/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M35.418 80.832l-17.5-17.5L23.75 57.5l11.668 11.668L76.25 28.332l5.832 5.836z"/>'
  }
})
